// extracted by mini-css-extract-plugin
module.exports = {"errorInfoWrapper":"_404-module--errorInfoWrapper--2yt5I","errorInfo":"_404-module--errorInfo--3Td4x","title":"_404-module--title--3oEiq"};